import { loadDefaultLanguage } from '@v4/locale/async';
import Header from '@v4/header';

(async () => {
    await loadDefaultLanguage();

    const yoastFaqBlockElm = document.querySelector('.wp-block-yoast-faq-block');

    if (yoastFaqBlockElm) {
        import(/* webpackChunkName: "YoastFaq" */ '@v4/common/components/organisms/YoastFaq')
            .then(({ default: YoastFaq }) => YoastFaq().init().triggerAccordion(0));
    }

    if (document.getElementById('header')) {
        Header();
    }
})();
